module.exports = __webpack_public_path__ + "static/img/flags.68c2a169.png";